// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__JOktS","modalFooterButton":"ModalNotes_modalFooterButton__6lTeU"};